module.exports = __webpack_public_path__ + "static/media/both-sides-arrow.ed6b1d11.svg";